export default __webpack_public_path__ + "static/media/blockedUserImg.7f00e6cf.svg";